import axios from "./axios";

export async function fetchWorkSchedules() {
  const res = await axios.get("/work_schedules");
  return res.data;
}

export async function fetchWorkSchedule(id) {
  const res = await axios.get(`/work_schedules/${id}`);
  return res.data;
}

export async function createWorkSchedule(payload) {
  const res = await axios.post("/work_schedules", { work_schedule: payload });
  return res.data;
}

export async function updateWorkSchedule(id, payload) {
  const res = await axios.put(`/work_schedules/${id}`, { work_schedule: payload });
  return res.data;
}

export async function deleteWorkSchedule(id) {
  await axios.delete(`/work_schedules/${id}`);
}
